//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GroupImg from '@/components/views/_group_img'

const IMG_PREFIX = 'https://cdn.vip-wifi.com/fangchan/img/find_building/swiper/'

const DEFAULT_BANNERS = [
    {
        img: `${IMG_PREFIX}join-group.png`,
        log: '入群引导',
        box_img_url: 'https://cdn.vip-wifi.com/timg/c6de3e8551286d2728da2b3cd91be8d120210923.jpeg',
    },
    {
        img: `${IMG_PREFIX}long-rent.png`,
        log: '长租公寓',
        link: '/pages/list/long_rent/main'
    }
]

export default {
    data() {
        return {
            banners: DEFAULT_BANNERS,
            show_add_group_img: false,
            bottom_add_group_url: '',
        }
    },
    components: {
        GroupImg,
    },
    methods: {
        tapItem(item) {
            const { link, box_img_url, log } = item
            this.$sendCtmEvtLog(`找房页面-banner点击-${log}`)
            if (link) {
                wx.navigateTo({
                    url: link
                })
            } else {
                this.show_add_group_img = true
                this.bottom_add_group_url = box_img_url
            }
        }
    }
}
